import {
  CASE_FETCH_DIALIN_NUMBERS_BEGIN,
  CASE_FETCH_DIALIN_NUMBERS_SUCCESS,
  CASE_FETCH_DIALIN_NUMBERS_FAILURE,
  CASE_FETCH_DIALIN_NUMBERS_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const fetchDialInNumbers = createPromiseAction(CASE_FETCH_DIALIN_NUMBERS_BEGIN);

export function dismissFetchDialInNumbersFeedback() {
  return {
    type: CASE_FETCH_DIALIN_NUMBERS_DISMISS_FEEDBACK,
  };
}

export function* doFetchDialInNumbers(action) {
  const { caseId } = action.payload;

  let res = yield call(api.get, `/cases/${caseId}/dial-in-numbers`);

  if (res && res.error) {
    yield put({
      type: CASE_FETCH_DIALIN_NUMBERS_FAILURE,
      feedback: {
        message: 'feedback.fetchDialInNumbersFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_FETCH_DIALIN_NUMBERS_SUCCESS,
    data: { dialInNumbers: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchFetchDialInNumbers() {
  yield takeLatest(fetchDialInNumbers, withCurrentCaseId(doFetchDialInNumbers));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_FETCH_DIALIN_NUMBERS_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        fetchDialInNumbersPending: true,
        fetchDialInNumbersFeedback: null,
      };

    case CASE_FETCH_DIALIN_NUMBERS_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchDialInNumbersPending: false,
        fetchDialInNumbersFeedback: action.feedback,
      };

    case CASE_FETCH_DIALIN_NUMBERS_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchDialInNumbersPending: false,
        fetchDialInNumbersFeedback: action.feedback,
      };

    case CASE_FETCH_DIALIN_NUMBERS_DISMISS_FEEDBACK:
      // Dismiss the request failure Feedback
      return {
        ...state,
        fetchDialInNumbersFeedback: null,
      };

    default:
      return state;
  }
}
